import { getPage, goToNewWindow, useBetsNavigation } from '../navigation';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { Home } from './home';
import { MyBets } from './my-bets';
import { SignUp } from './sign-up';
import { DynamicConfig, useServices } from '../services';
import config from '../config';
import { BetAhead } from './bet-ahead';
import { Block } from '@williamhill/rosi-ui-shared/src/components/typography';

const constructMobileUrl = ({ MOBILE_QUERY_PARAMS, SPORTSBOOK_BASE_URL }: DynamicConfig, state: String): string => {
  const url = `${SPORTSBOOK_BASE_URL}/${state}`;
  return MOBILE_QUERY_PARAMS ? `${url}?${MOBILE_QUERY_PARAMS}` : url;
};

const hasMobileSite = (dynamicConfig: DynamicConfig, state: string) =>
  !!dynamicConfig.MOBILE_STATES?.split(',').some(mobileState => mobileState === state) &&
  !!dynamicConfig.SPORTSBOOK_BASE_URL;

const constructBetAheadUrl = (dynamicConfig: DynamicConfig, region: String, state: String): string =>
  `${dynamicConfig.BET_AHEAD_BASE_URL}/${region}/${state}/bet?dl=retail_mode`;

const hasBetAhead = (dynamicConfig: DynamicConfig, state: string) =>
  !!dynamicConfig.BET_AHEAD_STATES?.split(',').some(mobileState => mobileState === state) &&
  !!dynamicConfig.BET_AHEAD_BASE_URL;

export default function NavigationBar() {
  const [mobileUrl, setMobileUrl] = useState<string | undefined>();
  const [betAheadUrl, setBetAheadUrl] = useState<string | undefined>();
  const { dynamicConfig, loading: isLoadingServices } = useServices();
  const location = useLocation();

  useEffect(() => {
    if (isLoadingServices || !dynamicConfig) {
      return;
    }

    const state = config.STATE;
    const region = config.REGION;

    if (hasMobileSite(dynamicConfig, state)) {
      setMobileUrl(constructMobileUrl(dynamicConfig, state));
    }

    if (hasBetAhead(dynamicConfig, state)) {
      setBetAheadUrl(constructBetAheadUrl(dynamicConfig, region, state));
    }
  }, [isLoadingServices, dynamicConfig]);

  const { goToBets, goToHome } = useBetsNavigation();

  return (
    <Container>
      <NavigationItem aria-label="Home" onClick={goToHome} isSelected={getPage(location.pathname) === 'Home'}>
        <Home />
      </NavigationItem>
      <NavigationItem aria-label="Bets" onClick={goToBets} isSelected={getPage(location.pathname) === 'Bets'}>
        <MyBets />
      </NavigationItem>
      {betAheadUrl && (
        <NavigationItem aria-label="Bet Ahead" onClick={() => goToNewWindow(betAheadUrl)} isSelected={false}>
          <BetAhead />
        </NavigationItem>
      )}
      {mobileUrl && (
        <NavigationItem aria-label="Sign Up" onClick={() => goToNewWindow(mobileUrl)} isSelected={false}>
          <SignUp />
        </NavigationItem>
      )}
    </Container>
  );
}

const Container = styled(Block)`
  display: flex;
  align-items: center;
  justify-items: stretch;
  height: 5.4rem;
  color: ${({ theme }) => theme.components.mobile.tab.item};
  background: ${({ theme }) => theme.colors.white};
`;

const NavigationItem = styled.nav<{ isSelected: boolean }>`
  font-weight: ${({ isSelected }) => (isSelected ? '600' : '400')};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.components.mobile.tab.selection : theme.components.mobile.tab.item};
`;
